import React, { createContext, useState } from "react";

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);

  // ✅ Add item (separate by id+weight)
  const addToCart = (product) => {
    setCart((prevCart) => {
      const existing = prevCart.find((item) => item.key === product.key);

      if (existing) {
        // if already in cart, just increase qty
        return prevCart.map((item) =>
          item.key === product.key
            ? { ...item, qty: item.qty + 1 }
            : item
        );
      } else {
        // new variation, add with qty 1
        return [...prevCart, { ...product, qty: 1 }];
      }
    });
  };

  // ✅ Decrease quantity
  const decreaseQty = (product) => {
    setCart((prevCart) =>
      prevCart
        .map((item) =>
          item.key === product.key
            ? { ...item, qty: item.qty - 1 }
            : item
        )
        .filter((item) => item.qty > 0) // remove if qty = 0
    );
  };

  // ✅ Remove completely
  const removeFromCart = (key) => {
    setCart((prevCart) => prevCart.filter((item) => item.key !== key));
  };

  const clearCart = () => {
    setCart([]); // reset cart to empty
  };

  // ✅ Total Price (using per-variation price)
  const totalPrice = cart.reduce(
    (sum, item) => sum + item.price * item.qty,
    0
  );

  return (
    <CartContext.Provider
      value={{
        cart,
        addToCart,
        decreaseQty,
        removeFromCart,
        clearCart,
        totalPrice,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
